import React from "react";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import {
  Box,
  Dialog,
  DialogContent,
  Drawer,
  Typography,
  useMediaQuery,
} from "@mui/material";
import PrimaryButton from "widgets/Buttons/PrimaryButton";
import { ALREADY_MODIFIED_ERROR_CODE } from "constants/config";


const CONTENT_BY_CODE = {
  [ALREADY_MODIFIED_ERROR_CODE.PROPOSAL_ALREADY_ACCEPTED]: {
    title: "Modification already accepted",
    description:
      "You may reach out to our customer support team at 1800-570-6262 for further assistance.",
  },
  [ALREADY_MODIFIED_ERROR_CODE.PROPOSAL_ALREADY_REJECTED]: {
    title: "Modification already rejected",
    description:
      "You may reach out to our customer support team at 1800-570-6262 for further assistance.",
  },
  [ALREADY_MODIFIED_ERROR_CODE.ORDER_PROPOSAL_NOT_FOUND]: {
    title: "Proposal not found",
    description:
      "We could not find this order modification proposal. It may be invalid or no longer available.",
  },
};

const defaultContent = {
  title: "Unable to continue",
  description: "Something went wrong. Please try again later.",
};

const AlreadyModifiedOrderDialog = ({
  open,
  onClose,
  errorCode,
  onOkay,
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { title, description } =
    CONTENT_BY_CODE[errorCode] ?? defaultContent;

  const handleOkay = () => {
    if (onOkay) onOkay();
  };

  const content = (
    <Box sx={{ p: 3, textAlign: "center" }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          border: "2px solid #004795",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#004795",
          mx: "auto",
          mb: 2,
        }}
      >
        <InfoOutlined sx={{ fontSize: "1.35rem" }} />
      </Box>
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 1.5, fontSize: "1.2rem" }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "text.secondary", mb: 3, fontSize: "0.95rem" }}
      >
        {description}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <PrimaryButton onClick={handleOkay}>Okay</PrimaryButton>
      </Box>
    </Box>
  );

  if (isMobile) {
    return (
      <Drawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            maxWidth: 480,
            mx: "auto",
          },
        }}
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>{content}</DialogContent>
    </Dialog>
  );
};

export default AlreadyModifiedOrderDialog;
